import {useState, useRef, useEffect, useCallback} from 'preact/hooks';
import cn from 'classnames';
import {useOnMount} from '@baidu/bce-hooks';
import {throttle} from 'lodash';

import {moduleDescCn} from '~/locals/aigallery/index';
import styles from '~/style/aigallery/component.module.less';
import arrowIcon from '~/assets/qf/leftarrow.svg';
import {useQfScreen} from '../../comp/utils/hook';

const Segmented = props => {
    const {screenWidth} = useQfScreen();
    const {options, value, onChange, isGrey = false} = props;
    const [maxDistance, setMaxDistance] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [index, setIndex] = useState(0);
    const [bgStyle, setBgStyle] = useState({
        left: 0,
        width: 0,
    })
    const contentDom = useRef(null);
    const containerDom = useRef(null);
    const viewDistance = useRef(0);

    const initNavBaseData = useCallback(
        throttle(() => {
            if (contentDom.current && containerDom.current) {
                const contentWidth = contentDom.current.offsetWidth;
                const containerWidth = containerDom.current.offsetWidth;
                viewDistance.current = containerWidth;
                setMaxDistance(contentWidth - containerWidth);
            }
        }, 100),
        []
    );

    useOnMount(() => {
        setTimeout(() => {
            initNavBaseData();
        }, 300);
    });

    

    useEffect(() => {
         if (contentDom.current && containerDom.current && screenWidth) {
            const {offsetLeft, offsetWidth} = contentDom.current.children[index+1];
            setBgStyle({
                left: offsetLeft,
                width: offsetWidth
            })
         }
    }, [index, screenWidth]);

    useEffect(() => {
        initNavBaseData();
        window.addEventListener('resize', initNavBaseData);
        return () => {
            window.removeEventListener('resize', initNavBaseData);
        };
    }, [options]);

    return (
        <div className={cn(styles.segmented, isGrey && styles['segmented-bg-white'], `${moduleDescCn}`)}>
            <div
                className={styles['segmented-container-wrapper']}
                ref={containerDom}
                onScroll={e => {
                    setScrollLeft(e.target.scrollLeft);
                }}
            >
                <ul ref={contentDom} className={styles['segmented-container']}>
                    <div className={styles.bg} style={{
                        ...bgStyle,
                        backgroundColor: isGrey ? '#f6f7fa' : '#fff',
                    }}></div>
                    {options.map((option, index) => (
                        <li
                            key={option.value}
                            className={cn(styles['segmented-item'], {
                                [styles.active]: !isGrey && value === option.value,
                                [styles['active-grey']]: isGrey && value === option.value
                            })}
                            onClick={() => {
                                onChange(option.value);
                                setIndex(index);
                            }}
                        >
                            {option.icon}
                            <span className={styles.label}>{option.label}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div
                className={cn(styles['scroll-btn'], styles['scroll-btn-left'], scrollLeft > 0 && styles['btn-show'])}
                onClick={() => {
                    containerDom.current.scroll({
                        left: 0,
                        behavior: 'smooth'
                    });
                    setScrollLeft(0);
                }}
            >
                <img src={arrowIcon} />
            </div>
            <div
                className={cn(
                    styles['scroll-btn'],
                    styles['scroll-btn-right'],
                    maxDistance > 0 && scrollLeft < maxDistance - 1 && styles['btn-show']
                )}
                onClick={() => {
                    const max = containerDom.current.offsetWidth;
                    containerDom.current.scroll({
                        left: max,
                        behavior: 'smooth'
                    });
                    setScrollLeft(max);
                }}
            >
                <img src={arrowIcon} />
            </div>
        </div>
    );
};

export default Segmented;
